import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

const TooltipIcon = ({
  tooltipKey,
  tooltipText,
  placement = 'top',
  icon = faInfoCircle,
  size = 'sm',
  color = '#6c757d'
}) => {
  if (!tooltipText) return null
  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: 250, hide: 200 }}
      overlay={<Tooltip id={`tooltip-${tooltipKey}`}>{tooltipText}</Tooltip>}
    >
      <span style={{ marginLeft: 6, cursor: 'pointer' }}>
        <FontAwesomeIcon icon={icon} size={size} color={color} />
      </span>
    </OverlayTrigger>
  )
}

export default TooltipIcon
